<template>
    <div class="row">
        <div class="col-xs-12 text-xs-left">
            <h3 class="modal__title">{{ $t('ARE_YOU_UP_TO_DATE') }}</h3>
            <br /><br />
            <p>
                <strong>{{ $t('VERY_IMPORTANT_FOR_BRASTER') }}</strong>
            </p>
            <ul>
                <li>
                    {{ $t('UP_TO_DATE_1') }}
                </li>
                <li>
                    {{ $t('UP_TO_DATE_2') }}
                </li>
                <li>
                    {{ $t('UP_TO_DATE_3') }}
                </li>
            </ul>
            <strong>{{ $t('ARE_YOU_UP_TO_DATE_2') }}</strong>

            <div class="text-center">
                <button
                    class="app-btn app-btn--small app-btn-primary-reverse --no-border --no-bg"
                    @click="$emit('gotomydata')"
                >
                    {{ $t('NO_I_WANT_TO_CHECK') }}
                </button>
                <button class="app-btn app-btn--big app-btn-primary" @click="$emit('close')">
                    {{ $t('YES') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
ul {
    padding: 10px 20px;
}

li {
    margin: 0 0 10px;
}
</style>



// WEBPACK FOOTER //
// are-you-up-to-date.vue?0abe804e